import { useEffect } from "react";

import { enableSiteImproveTracking } from "./siteimprove";

export function useSiteImprove(ready: boolean): void {
  useEffect(() => {
    if (ready) {
      enableSiteImproveTracking();
    }
  }, [ready]);
}
